/* eslint-disable max-len */
import { useEffect, useRef, useState } from 'react';
import { useAsync } from 'react-use';
import { Col, Form, Image, Input, Popover, Row, Tabs, Tag, Typography } from 'antd';
import Cookies from 'js-cookie';
import CardC from 'src/components/Card';
import { ButtonOK } from 'src/components/Forms/Button';
import IconCustom from 'src/components/Icon/Custom';
import DatePickerKalkulatorHpl from 'src/components/KalenderKehamilan/DatePickerHpl';
import DisclaimerHpl from 'src/components/KalenderKehamilan/DisclaimerHpl';
import KehamilanResult from 'src/components/KalenderKehamilan/KehamilanResult/KehamilanResult';
import { RESULT_CHECK_HEALTHTOOLS } from 'src/constants/localStorage';
import { useCalculateHPL } from 'src/hooks/useCalculateFertility';
import { changeFormatDate } from 'src/utils/func/kalender-kehamilan';
import dayjs from 'src/utils/moment';
import style from './style.module.less';
const {
  TabPane
} = Tabs;
const HariPerkiraanLahir = (props: any) => {
  const {
    router
  } = props;
  const [form] = Form.useForm();
  const [disable, setDisable] = useState(true);
  const [showReusult, setShowResult] = useState(false);
  const [listDay, setListDay] = useState<any>();
  const myRef = useRef<any>(null);
  const onResetForm = () => {
    if (router?.query?.uid) {
      router.push('/kalender-kehamilan/cek');
    }
    setShowResult(false);
    setDisable(false);
    form.setFieldsValue({
      longTime: 7,
      menstrual: 28
    });
    localStorage.removeItem(RESULT_CHECK_HEALTHTOOLS);
  };
  const handleHpht = () => {
    setDisable(false);
  };
  const [tabsKey, setTabsKey] = useState('1');
  const handleTab = (key: any) => {
    setDisable(true);
    form.resetFields();
    setTabsKey(key);
  };
  const [week, setWeek] = useState(0);
  const handleWeek = (e: any) => {
    const value = Number(e.target.value);
    if (!isNaN(value) && value >= 4 && value <= 41) {
      setWeek(value);
      setDisable(false);
    } else {
      setDisable(true);
    }
  };
  useAsync(async () => {
    try {
      const Url = `${process.env.NEXT_PUBLIC_PARTNER}/sign`;
      const data = {
        grant_type: `${process.env.NEXT_PUBLIC_GT_GRANT_TYPE}`,
        client_id: `${process.env.NEXT_PUBLIC_GT_CLIENT_ID}`,
        client_secret: `${process.env.NEXT_PUBLIC_GT_CLIENT_SECRET}`
      };
      const urlEncodedData = new URLSearchParams(data).toString();
      const opt = {
        method: 'POST',
        headers: {
          Accept: 'application/x-www-form-urlencoded',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: urlEncodedData
      };
      const signfeedback = await fetch(Url, opt);
      const dataNew = await signfeedback.json();
      dataNew.status = signfeedback.status;
      if (dataNew.status === 200) {
        Cookies.set('Token', JSON.stringify(dataNew.access_token), {
          expires: 1
        });
      }
    } catch (error) {}
  }, []);
  const {
    mutate: updateData,
    isPending
  } = useCalculateHPL({
    onSuccess: async (response: any) => {
      const formValues = form.getFieldsValue();
      setShowResult(true);
      setListDay(response.data.record);
      localStorage.setItem(RESULT_CHECK_HEALTHTOOLS, JSON.stringify({
        ...response?.data?.record,
        hpht: dayjs(formValues.calendar).format('DD/MM/YYYY')
      }));
    }
  });
  const onFinish = async () => {
    const formValues = form.getFieldsValue();
    if (formValues.calendar) {
      const payload = {
        hpht: dayjs(formValues.calendar).format('YYYY-MM-DD')
      };
      updateData(payload);
    } else if (week > 0) {
      const payload = {
        pregnancy_week: week
      };
      updateData(payload);
    }
  };
  useEffect(() => {
    if (!form.getFieldValue('longTime')) {
      form.setFieldsValue({
        longTime: 7,
        menstrual: 28
      });
    }
  }, []);
  useEffect(() => {
    if (myRef.current) {
      setTimeout(() => {
        myRef?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 500);
    }
  }, [showReusult]);
  useEffect(() => {
    const resultLocalStorage = JSON.parse(localStorage.getItem(RESULT_CHECK_HEALTHTOOLS) as any);
    if (resultLocalStorage && resultLocalStorage.check_type) {
      updateData({
        // check_type: resultLocalStorage.check_type as string,
        start_date: resultLocalStorage.hpht as string,
        mens_cycle: parseInt(resultLocalStorage.menstrual_cycle as string),
        mens_duration: parseInt(resultLocalStorage.menstrual_period as string)
      });
      form.setFieldsValue({
        calendar: dayjs(changeFormatDate(resultLocalStorage.hpht as string)),
        longTime: parseInt(resultLocalStorage.menstrual_period as string),
        menstrual: parseInt(resultLocalStorage.menstrual_cycle as string)
      });
    }
  }, []);
  const renderResult = () => {
    return <div ref={myRef}>
				<KehamilanResult router={router} listDay={listDay} onRetest={() => onResetForm()} />
			</div>;
  };
  const content1 = <div>
			<Typography className={style.paragraph}>
				Isi dengan tanggal pertama Mama mulai haid terakhir, ya!
			</Typography>
		</div>;
  const content2 = <div>
			<Typography className={style.paragraph}>
				Isi usia kehamilan Mama sekarang (antara 4 sampai 41 minggu) untuk hitung perkiraan hari lahir si kecil!
			</Typography>
		</div>;
  useEffect(() => {
    window.scrollBy({
      top: 5,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return <div className={style.question}>
			<div className={style.inputForm}>
				<div>
					<div className="d-flex justify-content-center">
						<CardC className={style.card}>
							<h1 className={style.title}>Hari Perkiraan Lahir</h1>
							<div className={style.images}>
								<Image src="/images/kalender-hpl/hero-hpl.webp" alt="image" preview={false} style={{
                width: 250,
                height: 250,
                cursor: 'pointer'
              }} />
							</div>
							<div>
								<Tabs defaultActiveKey="1" onChange={handleTab} className={style.customTabs}>
									<TabPane tab={<h2 className={style.customtab} style={{
                  color: tabsKey === '1' ? '#F48A8A' : '#BFAFAF'
                }}>Hitung Dengan HPHT</h2>} key="1">
										<div className={style.form}>
											<Form form={form} validateTrigger="onBlur" layout="vertical" onFinish={onFinish} autoComplete="off" name="ant-info-custom" style={{
                      marginBottom: 0
                    }}>
												<Row>
													<Col span={21}>
														<Form.Item className="position-relative" label={<span style={{
                            color: '#4A5454',
                            fontWeight: '400'
                          }}>
																	Hari pertama Haid terakhir
																</span>}>
															<DatePickerKalkulatorHpl className={style.inputCalendar} onChange={handleHpht} />
														</Form.Item>
													</Col>
													<Col span={3}>
														<Form.Item
                          // className="position-relative"
                          label="  " className={style.informasilabel}>
															<Popover content={content1} trigger="click" placement="bottomRight">
																<IconCustom iconName="kkInfo" />
															</Popover>
														</Form.Item>
													</Col>
													<Col className="d-flex justify-content-center" span={24}>
														<Form.Item style={{
                            marginTop: '-70px'
                          }}>
															<ButtonOK className={style.buttonSubmit} block htmlType="submit" text={'Hitung'} disabled={disable} loading={isPending} />
														</Form.Item>
													</Col>
												</Row>
											</Form>
										</div>
									</TabPane>
									<TabPane tab={<h2 className={style.customtab} style={{
                  color: tabsKey === '2' ? '#F48A8A' : '#BFAFAF'
                }}>Hitung Dengan Usia Kehamilan</h2>} key="2">
										<div className={style.form}>
											<Form form={form} validateTrigger="onBlur" layout="vertical" onFinish={onFinish} autoComplete="off" name="ant-info-custom">
												<Row>
													<Col span={21}>
														<Form.Item className="position-relative" label={<span style={{
                            color: '#4A5454',
                            fontWeight: '400'
                          }}>
																	Usia kehamilan
																</span>} rules={[{
                            required: true,
                            message: 'Please input your week!'
                          }, {
                            type: 'number',
                            min: 4,
                            max: 41,
                            message: 'Input must be a number between 0 and 44!'
                          }]}>
															{/* <DatePickerKalkulator className={style.inputCalendar} /> */}
															<Input min={4} max={41} placeholder="Usia kehamilan Mama" suffix={<Tag color="red" style={{
                              borderRadius: '12px',
                              padding: '5px 15px 5px 15px',
                              border: 'none'
                            }}>
																		<span style={{
                                color: '#F48A8A'
                              }}>Minggu</span>
																	</Tag>} className={style.input} type="number" onChange={handleWeek} />
														</Form.Item>
													</Col>
													<Col span={3}>
														<Form.Item
                          // className="position-relative"
                          label="  " className={style.informasilabel}>
															<Popover content={content2} trigger="click" placement="bottomRight">
																<IconCustom iconName="kkInfo" />
															</Popover>
														</Form.Item>
													</Col>
													<Col className="d-flex justify-content-center" span={24}>
														<Form.Item>
															<ButtonOK className={style.buttonSubmit} block htmlType="submit" text={'Hitung'} disabled={disable} loading={isPending} />
														</Form.Item>
													</Col>
												</Row>
											</Form>
										</div>
									</TabPane>
								</Tabs>
							</div>
						</CardC>
					</div>
					{showReusult ? <div className="d-flex justify-content-center">
							<DisclaimerHpl></DisclaimerHpl>
						</div> : ''}
					{showReusult ? <div className="d-flex justify-content-center">{renderResult()}</div> : ''}
				</div>
			</div>
		</div>;
};
export default HariPerkiraanLahir;